class LinkSanitizer {
  constructor(options = {}) {
    this.options = {
      resultSelector: '.ewd-otp-tracking-results-value',
      containerSelector: '.ewd-otp-tracking-results',
      trackingUrlBase:
        'https://www.ponyexpress.ru/support/servisy-samoobsluzhivaniya/track/?_&trace_ids=',
      ...options,
    };
    this.observer = null;
    this.processedNodes = new Set();
  }

  unescapeHTML(escapedHTML) {
    return escapedHTML
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'")
      .replace(/&amp;/g, '&');
  }

  cleanUrl(url) {
    return url.replace(/\\?(\\*")/g, '').replace(/\\\\/g, '\\');
  }

  processContent(content) {
    // Сначала пробуем найти и исправить существующие ссылки
    const linkRegex = /<a\s+href=(?:\\?")?(.+?)(?:\\?")?>(.*?)<\/a>/g;
    let processedContent = content.replace(linkRegex, (match, url, text) => {
      const cleanedUrl = this.cleanUrl(url);
      return `<a href="${cleanedUrl}" target="_blank">${text}</a>`;
    });

    // Если ссылок нет, ищем номер отслеживания и создаем ссылку
    if (!linkRegex.test(content)) {
      const trackingNumberRegex = /\b(\d{2}-\d{4}-\d{4})\b/g;
      processedContent = processedContent.replace(trackingNumberRegex, (match, trackingNumber) => {
        const url = `${this.options.trackingUrlBase}${trackingNumber}`;
        return `<a href="${url}" target="_blank">${trackingNumber}</a>`;
      });
    }

    return processedContent;
  }

  processResults() {
    $(this.options.resultSelector).each((index, element) => {
      if (!this.processedNodes.has(element)) {
        const $element = $(element);
        const content = $element.html();
        if (content && content.trim() !== '') {
          const unescapedContent = this.unescapeHTML(content);
          const processedContent = this.processContent(unescapedContent);
          $element.html(processedContent);
          this.processedNodes.add(element);
        }
      }
    });
  }

  startObserving() {
    const container = document.querySelector(this.options.containerSelector);
    if (!container) {
      console.warn(`Container ${this.options.containerSelector} not found`);
      return;
    }

    this.observer = new MutationObserver((mutations) => {
      let shouldProcess = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          shouldProcess = true;
        }
      });
      if (shouldProcess) {
        this.processResults();
      }
    });

    this.observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  stopObserving() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  init() {
    $(document).ready(() => {
      this.startObserving();
      // Initial process in case content is already there
      this.processResults();
    });
  }
}

export default LinkSanitizer;
